import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { generatePath, Link, useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { getDiscountPrice } from "../../helpers/product";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import CustomerModal from "./modals/modalCustomer";
import { adjustCartForCheckOut } from "../../redux/actions/cartActions";
import { CircularProgress } from "@material-ui/core";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";

const PreCheckout = ({
  location,
  cartItems,
  currency,
  userData,
  adjustCartForCheckOut,
}) => {
  const { pathname } = location;
  let cartTotalPrice = 0;
  var strings = require("../../translations/italian.json");
  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [showModalSedi, setShowModalSedi] = useState(false);
  const [customerArray, setCustomerArray] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [onClick, setOnClick] = useState(0);
  const [IdDetCliSed, setIdDetCliSed] = useState(0);
  const [idCli, setIdCli] = useState(0);
  const [clienti, setClienti] = useState([]);
  const [sedi, setSedi] = useState([]);
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [goToCheckOut, setGoToCheckout] = useState(false);
  const history = useHistory();
  useEffect(() => {
    caricaAnagrafica();
  }, []);
  var informazioni = global.informazioni;

  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    risultatoAnagrafica = await fetchAnagrafica({ username, password });
    var risultatoSede;
    if (!risultatoAnagrafica || !risultatoAnagrafica.Anagrafica)
      return risultatoAnagrafica;

    if (risultatoAnagrafica.Anagrafica.length > 1) {
      indexAnagraficaScelta = SegliAnagrafica(risultatoAnagrafica);
    } else {
      setIdCli(risultatoAnagrafica.Anagrafica[0].IdCli);
      setCustomerArray(risultatoAnagrafica.Anagrafica);
    }
    return risultatoAnagrafica;
  };
  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente");
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc;
      item.id = item.IdCli;
      return item;
    });
    setCustomerArray(risultatoAnagrafica.Anagrafica);
    setOnClick(1);
    setShowModalCustomer(true);
  };

  const ScegliSede = (cliente) => {
    setModalTitle("Scegli la destinazione");
    var sediLocal = cliente == undefined && cliente.Sedi ? [] : cliente.Sedi;
    if (sediLocal && sediLocal.length > 0) {
      if (sediLocal.length > 1) {
        setSedi(
          sediLocal.map((item) => {
            item.value =
              item.dessedcli != undefined ? "[" + item.dessedcli + "] " : "";
            item.value +=
              item.IndSed +
              ", " +
              item.CAP +
              " " +
              item.Loc +
              " (" +
              item.Pro +
              ") - " +
              item.NAZ;
            item.id = item.IdDetCliSed;
            return item;
          })
        );
        setOnClick(2);
        //console.log(onClick)
        setShowModalSedi(true);
      } else {
        setIdDetCliSed(sediLocal[0].IdDetCliSed);
      }
    } else {
      if (IdDetCliSed == 0) setIdDetCliSed(-1);
      if (IdDetCliSed == -1) setIdDetCliSed(0);
    }
  };

  useEffect(() => {
    if (idCli != 0) setGoToCheckout(true);
    setShowModalCustomer(false);
    if (customerArray.length == 0 || idCli == 0) return;
    var cliente = customerArray.filter((c) => c.IdCli === idCli)[0];
    //console.log(cliente)
    sessionStorage.setItem("cliente", JSON.stringify(cliente));
    setSedi(cliente ? cliente.Sedi : []);
    ScegliSede(cliente);
  }, [idCli, customerArray]);

  useEffect(() => {
    //console.log(IdDetCliSed)
    setShowModalCustomer(false);
    AggiustaCarrello();
    setinCaricamentoCheckOut(false);
  }, [IdDetCliSed]);

  const AggiustaCarrello = async () => {
    var risultatoCarrello = {};
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var item = {};
    var pcartData = [];

    cartItems.map((cartItem, key) => {
      item = {};
      item.qty = cartItem.quantity;
      item.idArt = cartItem.selectedIDArt;
      item.catalogo = cartItem.catalogo;
      item.id = cartItem.id;
      pcartData[key] = item;
    });
    ////console.log(pcartData)
    var localIdCli = idCli;
    risultatoCarrello = await fetchSendCartData({
      username,
      password,
      pcartData,
      idCli,
    });

    if (risultatoCarrello.item == undefined) return;
    //console.log(risultatoCarrello);
    sessionStorage.setItem(
      "condizioni",
      JSON.stringify(risultatoCarrello.condizioni)
    );
    const condizioni = JSON.parse(
      sessionStorage.getItem("condizioni") != "undefined"
        ? sessionStorage.getItem("condizioni")
        : "[]"
    );
    const itemsNoSco = JSON.parse(
      sessionStorage.getItem("itemsNoSco") != "undefined"
        ? sessionStorage.getItem("itemsNoSco")
        : "[]"
    );
    const personal = risultatoCarrello?.personal;
    //console.log(personal)
    risultatoCarrello.item.map((item, key) => {
      const cond = condizioni.find((cond) => cond.IDArt == item.idArt);

      var itemC = cartItems.filter(
        (itemCs) => itemCs.selectedIDArt === item.idArt
      )[0];
      //console.log("Aggiornato " + itemC.quantity)

      itemC.qtyOK = item.qtyOK;
      itemC.qtyArr = item.qtyArr;
      itemC.qtyNO = item.qtyNO;
      itemC.qtyPre = item.qtyPre;
      //itemC.price = item.price;
      itemC.sco1 = item.sco1;
      itemC.sco2 = item.sco2;
      itemC.sco3 = item.sco3;
      itemC.sco4 = item.sco4;
      itemC.priceIva = item.priceIva;
      console.log(item.priceIva);
      var priceSco = item.pricesco; //prezzo già scontato con listino personale

      var itemSenzaSconto = itemsNoSco.find(
        (itemS) => itemS.IDArtBas === itemC.id
      );
      var priceScoPre = itemSenzaSconto
        ? item.priceNoSco * (cond?.Sco ? 1 - cond?.Sco / 100.0 : 1)
        : item.priceNoSco *
          (cond?.Sco > personal.S1
            ? 1 - cond?.Sco / 100.0
            : 1 - personal.S1 / 100.0);
      var priceScoLis = itemSenzaSconto
        ? item.priceNoSco
        : item.priceNoSco * (1 - item.sco1 / 100.0) * (1 - item.sco2 / 100.0);
      if (!itemSenzaSconto || cond) {
        if (priceSco > cond?.Pre && cond?.Pre > 0) {
          priceSco = cond?.Pre;
          itemC.tipoSconto = 1; //prezzo fisso
        }
        if (priceSco >= priceScoPre) {
          itemC.sco1 =
            cond?.Sco > personal.S1 || itemSenzaSconto
              ? cond?.Sco
              : personal.S1;
          priceSco = priceScoPre;
          itemC.tipoSconto = 2; //sconto in percetuale
        }
        if (priceSco >= priceScoLis) {
          itemC.sco1 = item.sco1;
          priceSco = priceScoLis;
          itemC.tipoSconto = 2; //sconto in percetuale
        }
        if (priceSco != item.priceNoSco && !itemC.tipoSconto) {
          if (personal.S1 > 0) {
            itemC.sco1 = personal.S1;
            itemC.tipoSconto = 2; //sconto in percetuale
          } else {
            itemC.tipoSconto = 1; //prezzo fisso
          }
        }
      }

      itemC.pricesco = priceSco;
      itemC.priceNoSco = item.priceNoSco;
      adjustCartForCheckOut(itemC);
      //console.log("Aggiornato " +itemC.quantity)
    });
    sessionStorage.removeItem("condizioni");
    //console.log("risultato carrello "+JSON.stringify(risultatoCarrello));
    sessionStorage.setItem("idCli", idCli);
    sessionStorage.setItem("idDetCliSed", IdDetCliSed);
    var cliente = customerArray.filter((cliente) => cliente.IdCli == idCli)[0];
    var sede = cliente
      ? cliente.Sedi.filter((sede) => sede.IdDetCliSed == IdDetCliSed)[0]
      : undefined;
    if (sede)
      sessionStorage.setItem(
        "sede",
        JSON.stringify(
          sedi.filter((sede) => sede.IdDetCliSed == IdDetCliSed)[0]
        )
      );
    //if(cliente.Sedi && cliente.Sedi.length > 0) sessionStorage.setItem("sede", JSON.stringify(cliente.Sedi.filter( sede => sede.IDDetCliSed == IdDetCliSed)[0]))
    sessionStorage.setItem(
      "spedizione",
      JSON.stringify(risultatoCarrello.spedizione)
    );
    sessionStorage.setItem("totSpeTra1", risultatoCarrello.totSpeTra1);
    sessionStorage.setItem("totSpeTra2", risultatoCarrello.totSpeTra2);
    sessionStorage.setItem("totSpeInc1", risultatoCarrello.totSpeInc1);
    sessionStorage.setItem("totSpeInc2", risultatoCarrello.totSpeInc2);
    sessionStorage.setItem("totSpeImb1", risultatoCarrello.totSpeImb1);
    sessionStorage.setItem("totSpeImb2", risultatoCarrello.totSpeImb2);
    sessionStorage.setItem(
      "personalCli",
      JSON.stringify(risultatoCarrello.personal)
    );
    sessionStorage.setItem(
      "localita",
      JSON.stringify(risultatoCarrello.localita)
    );
    sessionStorage.setItem(
      "pagamenti",
      JSON.stringify(risultatoCarrello?.Pagamenti)
    );
    if (goToCheckOut) history.push("checkout");
  };

  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.checkout} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.checkout + " " + strings.siteContent}
        />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Checkout
      </BreadcrumbsItem>
      <LayoutOne>
        <div style={{ height: 500 }}>
          <img
            style={{
              position: "absolute",
              margin: "auto",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            src="https://www.istitutomarangoni.com/fe-web/img/marangoni/loader.gif"
          />
        </div>
      </LayoutOne>
      <CustomerModal
        show={showModalCustomer}
        onHide={() => {
          setShowModalCustomer(false);
          setinCaricamentoCheckOut(false);
        }}
        array={customerArray}
        title={modalTitle}
        onClick={setIdCli}
      />

      <CustomerModal
        show={showModalSedi}
        onHide={() => {
          setShowModalCustomer(false);
          setinCaricamentoCheckOut(false);
        }}
        array={sedi}
        title={modalTitle}
        onClick={setIdDetCliSed}
      />
    </Fragment>
  );
};

PreCheckout.propTypes = {
  cartItems: PropTypes.array,
  currency: PropTypes.object,
  location: PropTypes.object,
  adjustCartForCheckOut: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    currency: state.currencyData,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adjustCartForCheckOut: (item) => {
      dispatch(adjustCartForCheckOut(item));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreCheckout);
